import logoAsset from "@/assets/logo.png.asset.json";
import { Link } from "@tanstack/react-router";

export function Footer() {
  return (
    <footer className="bg-brand-dark text-white py-20">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center gap-12 text-center md:text-left">
          <div>
            <img 
              src={logoAsset.url} 
              alt="Gopage" 
              className="h-12 w-12 rounded-xl object-contain mb-4 mx-auto md:mx-0" 
            />
            <p className="text-sm text-[#D1D5DB] max-w-xs">
              Fornecedores e atacadistas de todo o Brasil, organizados por segmento, cidade e polo atacadista.
            </p>
          </div>
          
          <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 text-sm font-semibold text-[#D1D5DB]">
            <Link to="/entrar" className="hover:text-[#C6F764] transition-colors">Entrar</Link>
            <Link to="/cadastro" className="hover:text-[#C6F764] transition-colors">Criar conta</Link>
            <Link to="/fornecedores" search={{}} className="hover:text-[#C6F764] transition-colors">Fornecedores</Link>
            <Link to="/guias" className="hover:text-[#C6F764] transition-colors">Guias</Link>
            <Link to="/quero-anunciar" className="hover:text-[#C6F764] transition-colors">Quero Anunciar</Link>
            <Link to="/contato" className="hover:text-[#C6F764] transition-colors">Contato</Link>
            <Link to="/termos-de-uso" className="hover:text-[#C6F764] transition-colors">Termos</Link>
            <Link to="/politica-de-privacidade" className="hover:text-[#C6F764] transition-colors">Privacidade</Link>
          </div>
        </div>
        
        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="text-sm font-bold text-[#D1D5DB]">
            Uma ferramenta Gopage
          </div>
          <p className="text-xs text-[#D1D5DB]/50">© 2026 Gopage. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
}